import { AbstractControl, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { Phrase } from './phrase';

export class Translation {
  constructor(cultureName: string, translationText: string) {
    this.cultureName = cultureName;
    this.translationText = translationText;
  }

  cultureName: string;
  translationText: string;

  private static _noValidation: ValidatorFn = () => null;
  private static _cannotRemove: ValidatorFn = (control: AbstractControl): ValidationErrors | null =>
    Validators.required(control) ? { cannotRemove: true } : null;

  /**
   * Requires a non-empty value if the value was non-empty initially.
   * @param initialValue The value used to initialize FormControl.value
   * @returns
   */
  public static cannotRemove(initialValue: Translation | string): ValidatorFn {
    if (initialValue && (typeof initialValue === 'string' || (initialValue as Translation).translationText)) {
      return this._cannotRemove;
    }
    return this._noValidation;
  }

  /**
   * Specifies that one -OR- all Translations in a Phrase is required.
   * @param options requireAll: true - Require all translations.
   *                source: AbstractControl - The real (hidden) control with the Translation[] as value (for form submit).
   */
  public static requireTranslation(phrase: Phrase, options?: { requireAll?: boolean; source?: AbstractControl }): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (options?.source?.untouched && control.value !== '') {
        // workaround to handle translationText control touching itself...
        return null;
      }
      if (
        options?.requireAll
          ? control.value && phrase.otherTranslations.every(x => !!x.translationText)
          : control.value || phrase.otherTranslations.some(x => !!x.translationText)
      ) {
        return null;
      }

      return { requireTranslation: true };
    };
  }
}
